import axios from "axios"


export const get_lang = (value, langValue) => { 
    var lang = langValue;
    var result = value.en;
    switch (lang) {
        case "en":
            result = value.en;
            break;
        case "ar":
            // result = value.en;
            result = value.ar ? value.ar : value.en;
            break;
            case "ch":
                // result = value.en;
                result = value.ch ? value.ch : value.en;
                break;
        default:
            result = value.en;
            break;
    }

    return result;
}

    export const get_lang_status = (value, langValue) => { 
        var lang = langValue;
        var result = value.en;
        switch (lang) {
            case "en":
                result = value.en ? true : false;
                break;
            case "ar":
                // result = value.en;
                result = value.ar ? true : false;
                break;
            default:
                result = true;
                break;
        }
    
        return result;
    } 


export const get_lang_search = (value, langValue) => {
    var lang = langValue;
    var result = value.en;

    switch (lang) {
        case "en":
            result = value.en;
            break;
        case "ar":
            result = value.en;
            // result = value.ar ? value.ar : value.en;
            break;
        default:
            result = value.en;
            break;
    }

    return result;
}

